import { CHAINID_URL_MAPPING } from '../constants'

export function getChainDataByChainId(chainId) {
    let obj = CHAINID_URL_MAPPING.find(o => o.chainId === chainId)
    if (!obj) return null
    return obj
}

export function getChainDataByUrlChainName(urlChainName) {
    let obj = CHAINID_URL_MAPPING.find(o => o.urlChainName === urlChainName)
    if (!obj) return null
    return obj
}